import { Type } from 'class-transformer';
import { OwnerBasicDetailsRawDto } from './owner-basic-details-raw-dto';

export class IndividualOwnerNameRawDto {
  @Type(() => OwnerBasicDetailsRawDto)
  firstOwner: OwnerBasicDetailsRawDto;
  @Type(() => OwnerBasicDetailsRawDto)
  secondOwner: OwnerBasicDetailsRawDto;
  combinedName: string;
}
